// extracted by mini-css-extract-plugin
module.exports = {"login":"loginIndex_login__32ICy","login-box":"loginIndex_login-box__1iGdr","logo":"loginIndex_logo__DXZ7U"};